<script>
  import { _ } from "svelte-i18n";
  import { onMount } from "svelte";
  import { currentPage } from "../../utilities/DataStore";
  import { BASE_URL } from "../../utilities/config.js";
  import { sanitizeAssessmentHtml } from "../../utilities/TextSanitizer.js";
  import { parseFillTheLetters } from "../fillTheLetters.mjs";
  import { parseDragWords } from "../dragWords.mjs";
  import { reportRecordings } from "../listenRepeat.mjs";

  export let instanceId;
  export let instanceData;

  const dateOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  };

  let progressBarOverall;
  let progressBarSpeaking;
  let progressBarReading;

  let scoreOverall = 75;
  let scoreSpeaking = 80;
  let scoreReading = 45;

  function initialize() {
    console.log(instanceData);
    if (instanceData) {
      let result = JSON.parse(instanceData?.reviewComment);
      scoreOverall = (160 * result?.sumScoreTotal) / result?.sumScoreTotalMax;
      scoreSpeaking =
        160 *
        (result?.sumScoreSpeakingTotal / result?.sumScoreSpeakingTotalMax);
      scoreReading =
        160 * (result?.sumScoreReadingTotal / result?.sumScoreReadingTotalMax);

      // createBar(progressBarOverall, scoreOverall ? scoreOverall : 0);
    }
    console.log("score", scoreOverall, scoreSpeaking, scoreReading);
  }

  let exerciseListStatus = "NEW";
  let progressListData = [];
  let progressListDataReport = [];

  async function loadDataProgress() {
    exerciseListStatus = "LOADING";
    return fetch(
      BASE_URL +
        `/public/assessment/instance/` +
        instanceId +
        `/progress-report`,
    )
      .then((response) => {
        if (!response.ok) {
          console.log("response error");

          throw new Error("Network response was not ok");
        }
        console.log("response ok", response);
        return response.json();
      })
      .then((data) => {
        progressListData = data;
        console.log("progressListData", progressListData);
        exerciseListStatus = "OK";
        progressListDataReport = data.flatMap((item) => {
          if (
            item.exerciseType === "INTRO" ||
            item.exerciseType === "PHOTO_VERIFICATION"
          ) {
            return [];
          } else if (item.exerciseType === "MULTICHOICE_COMBINED") {
            let o = JSON.parse(item?.answerData)?.selectedOptionList;
            let q = JSON.parse(item?.data)?.questions;
            o = o.map((x, i) => {
              return {
                exerciseType: item.exerciseType,
                name: `${item.name} - ${i + 1}`,
                normalizedScore: x?.correctOption ? 1 : 0,
                selectedValue: x?.selectedOption,
                correctOption: q[i].correctOption,
              };
            });
            return [...o];
          } else if (item.exerciseType === "FILL_THE_GAP") {
            // One row per gap. The correct answer is a regex pattern, so only
            // the student's answer and the per-gap verdict are shown.
            let gapAnswers = JSON.parse(item?.answerData)?.gapAnswerList || [];
            return gapAnswers.map((x, i) => {
              return {
                exerciseType: item.exerciseType,
                name: `${item.name} - ${i + 1}`,
                normalizedScore: x?.correct ? 1 : 0,
                selectedValue: x?.answer,
              };
            });
          } else if (
            item.exerciseType === "FILL_THE_LETTERS" ||
            item.exerciseType === "DRAG_WORDS"
          ) {
            // One row per word block / slot. The answer key is read from the
            // definition with the same parser the exercise page uses.
            let answerData = JSON.parse(item?.answerData);
            let data = JSON.parse(item?.data);
            let isLetters = item.exerciseType === "FILL_THE_LETTERS";
            let answers =
              (isLetters
                ? answerData?.letterAnswerList
                : answerData?.dragAnswerList) || [];
            let key = isLetters
              ? parseFillTheLetters(data, sanitizeAssessmentHtml).blocks.map(
                  (b) => b.text,
                )
              : parseDragWords(data, { sanitize: sanitizeAssessmentHtml }).slots.map(
                  (s) => s.answer,
                );
            return answers.map((x, i) => {
              return {
                exerciseType: item.exerciseType,
                name: `${item.name} - ${i + 1}`,
                normalizedScore: x?.correct ? 1 : 0,
                selectedValue: x?.answer,
                correctOption: key[i],
              };
            });
          } else {
            let x = {
              exerciseType: item.exerciseType,
              name: item.name,
              normalizedScore: item.normalizedScore,
            };
            if (
              item.exerciseType === "MULTICHOICE_SELECT" ||
              item.exerciseType === "LISTEN_WITH_IMAGE"
            ) {
              let a = JSON.parse(item?.answerData);
              let q = JSON.parse(item?.data);

              x["selectedValue"] = a?.selectedOption;
              x["correctOption"] = q?.correctOption;
            }
            if (
              item.exerciseType === "QUESTION" ||
              item.exerciseType === "READ" ||
              item.exerciseType === "LISTEN_REPEAT" ||
              item.exerciseType === "IMAGE"
            ) {
              x["recordingFileName"] = item?.recordingFileName;
              // One player per recorded sentence of a LISTEN_REPEAT series;
              // stored (Azure) URLs first, the GCS path only for old rows.
              x["recordings"] = reportRecordings(item);
            }

            return [x];
          }
        });
        console.log("progressListDataReport", progressListDataReport);
      })
      .catch((error) => {
        console.log("catch error", error);
        errorMsg = "ERROR_LOADING_ASSESSMENT";
        progressListData = undefined;
        exerciseListStatus = "ERROR";
      });
  }

  function formatScore(score) {
    if (score < 10) {
      return "0-15";
    } else if (score < 145) {
      let x =
        score % 10 < 5
          ? (score / 10).toFixed(0) + "0"
          : (score / 10 - 1).toFixed(0) + "5";
      return x + "-" + (+x + 15).toFixed(0);
    } else {
      return "145-160";
    }
  }

  onMount(() => {
    loadDataProgress();
    initialize();
  });

  function createBar(item, score) {
    let value = score / 160;
    let colorEnd = "#d12000";
    if (value < 0.2) {
      colorEnd = "#ed8d00";
    } else if (value < 0.4) {
      colorEnd = "#ed8d00";
    } else if (value < 0.55) {
      colorEnd = "#f1bc00";
    } else if (value < 0.7) {
      colorEnd = "#84c42b";
    } else if (value < 0.85) {
      colorEnd = "#53b83a";
    } else {
      colorEnd = "#3da940";
    }
    let bar = new ProgressBar.Line(item, {
      strokeWidth: 3,
      easing: "easeInOut",
      duration: 1000,
      color: "#FFEA82",
      trailColor: "#eee",
      trailWidth: 1,
      svgStyle: { width: "100%", height: "100%" },
      from: { color: "#d12000" },
      to: { color: colorEnd },
      step: (state, bar) => {
        bar.path.setAttribute("stroke", state.color);
      },
    });

    bar.animate(value);
  }

  function shareButton() {
    if (navigator.share) {
      navigator
        .share({
          title: "Share Sensay Assessment Report",
          url: `https://assessment.oksensay.com/#/certificate/${instanceId}`,
        })
        .then(() => {
          console.log("Thanks for sharing!");
        })
        .catch(console.error);
    } else {
      copyLink();
    }
  }

  let linkCopied = false;

  let timer;

  const debounce = (v) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      linkCopied = false;
    }, 5000);
  };

  function copyLink() {
    let url = `https://assessment.oksensay.com/#/certificate/${instanceId}`;
    copyTextToClipboard(url);
  }

  function copyTextToClipboard(text) {
    linkCopied = true;
    debounce();
    navigator.clipboard.writeText(text).then(
      function () {
        console.log("Async: Copying to clipboard was successful!");
      },
      function (err) {
        console.error("Async: Could not copy text: ", err);
      },
    );
  }
</script>

<div class="container paper-shadow">
  <div class="row justify-content-center">
    <div class="col sensayLogoSmall" style="">
      <img src="assets/img/logo_2_report.png" width="200px" alt="logo" />
    </div>
  </div>
  <div class="row">
    <div class="col-8">
      <h2>{$_("ASSESSMENT")}: {instanceData?.assessmentDefinitionCode}</h2>
      <h2>{instanceData?.clientName}</h2>
      <h6>
        {new Date(instanceData?.finishAt).toLocaleDateString(
          "en-US",
          dateOptions,
        )}
      </h6>
      <div>
        <i class="fas fa-lock ml-3"
          ><a
            class="ml-3 sensayLink"
            style="font-family: 'Noto Sans', sans-serif;"
            href="https://assessment.oksensay.com/#/certificate/{instanceId}"
            >assessment.oksensay.com/#/certificate/{instanceId}</a
          ></i
        >
      </div>
      <div>
        {#if linkCopied}
          <div class="badge bg-info">{$_("LINK_COPIED_TO_CLIPBOARD")}</div>
        {:else}
          <button class="btn" on:click={shareButton}
            ><i class="fas fa-share mr-3" />{$_("SHARE")}</button
          >
        {/if}
      </div>
    </div>
    <div class="col-4 sensayLogo" style="">
      <img src="assets/img/logo_2_report.png" width="200px" alt="logo" />
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <h4>{$_("OVERALL")}
      <span class="score text-right">{(instanceData?.normalizedScore * 100)?.toFixed(0)}%</span>
      </h4>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <h4>{$_("QUESTIONS")}</h4>
      <div>
        {$_("QUESTIONS_DESCRIPTION")}
      </div>

      <table class="table table-striped table-bordered mt-3">
        <thead>
          <tr>
            <th class="text-right">#</th>
            <th class="text-right">{$_("NAME")}</th>
            <th>{$_("SCORE")}</th>
            <th>{$_("SELECTED")}</th>
            <th>{$_("CORRECT")}</th>
          </tr></thead
        >
        <tbody>
          {#each progressListDataReport as q, i}
            {#if q?.exerciseType === "INTRO" || q?.exerciseType === "PHOTO_VERIFICATION"}
              <tr> </tr>
            {:else}
              <tr>
                <td class="text-right">
                  {i + 1}
                </td>
                <td class="text-right">
                  {q.name}
                </td>
                <td>
                  {#if q?.normalizedScore === 1}✅
                  {:else if q?.normalizedScore === 0}
                    ❌
                  {:else if q?.normalizedScore === null}
                    {$_("NOT_ANSWERED")}
                  {:else}
                    {(q?.normalizedScore * 100)?.toFixed(0)}%
                  {/if}
                </td>
                <td>
                  {q.selectedValue || ""}
                  {#if q?.exerciseType === "QUESTION" || q?.exerciseType ==="READ" || q?.exerciseType === "LISTEN_REPEAT" ||q?.exerciseType ==="IMAGE"}
                    {#each q?.recordings || [] as recording (recording.index)}
                      {#if q.recordings.length > 1}
                        <div class="small text-muted">{recording.index + 1}.</div>
                      {/if}
                      <audio controls>
                        <source
                          src={recording.url}
                          type="audio/ogg"
                        />
                        <track
                          default
                          kind="captions"
                          srclang="en"
                          src=""
                        />{$_("NOT_SUPPORTED")}</audio
                      >
                    {/each}
                  {/if}
                </td>
                <td
                  class:table-danger={q?.normalizedScore === 0 &&
                    q.correctOption}
                  >{q.correctOption || ""}
                  
                </td>
              </tr>
            {/if}
          {/each}
          <tr class="font-weight-bold">
            <td class="text-right">
              {$_("TOTAL")}
            </td>
            <td class="text-right">
              {progressListDataReport.length}
            </td>
            <td colspan="3" class="text-center">
              {(instanceData?.normalizedScore * 100)?.toFixed(0)}%
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="row justify-content-center">
    <a
      href="/"
      on:click={() => {
        $currentPage = "";
      }}>assessment.oksensay.com</a
    >
  </div>
</div>

<style>
  .sensayLogo {
    text-align: end;
    min-width: 200px;
  }
  .sensayLogoSmall {
    display: none;
  }

  @media (max-width: 768px) {
    .container {
      padding: 0;
    }

    .sensayLogo {
      max-width: 200px;
      display: none;
    }

    .sensayLogoSmall {
      display: block;
      flex-grow: 0;
    }

    .sensayScoreDetail {
      display: none;
    }

    .sensayLink {
      font-size: 2.5vw;
    }

    .score {
      font-size: 3.5vw !important;
    }
  }

  .score {
    color: #ffcc0c;
    font-size: x-large;
    font-weight: 700;
  }

  body {
    background: #dfe6e9;
  }
  .paper-shadow {
    position: relative;
    background: #fff;
    padding: 3rem;
    /* width: 50%; */
    margin: 50px auto;
    box-shadow: 0px 2px 38px rgba(0, 0, 0, 0.2);
    /* height: 400px; */
  }
  .paper-shadow:after,
  .paper-shadow:before {
    content: "";
    position: absolute;
    left: auto;
    background: none;
    z-index: -1;
  }
  .paper-shadow:after {
    width: 90%;
    height: 10px;
    top: 30px;
    right: 8px;
    -webkit-transform: rotate(-3deg);
    -moz-transform: rotate(-3deg);
    -o-transform: rotate(-3deg);
    -ms-transform: rotate(-3deg);
    transform: rotate(-3deg);
    -webkit-box-shadow: 0px -20px 36px 5px #295d92;
    -moz-box-shadow: 0px -20px 36px 5px #295d92;
    box-shadow: 0px -25px 35px 0px rgba(0, 0, 0, 0.5);
  }

  .paper-shadow:before {
    width: 10px;
    height: 95%;
    top: 5px;
    right: 18px;
    -webkit-transform: rotate(3deg);
    -moz-transform: rotate(3deg);
    -o-transform: rotate(3deg);
    -ms-transform: rotate(3deg);
    transform: rotate(3deg);
    -webkit-box-shadow: 20px 0px 25px 5px #295d92;
    -moz-box-shadow: 20px 0px 25px 5px #295d92;
    box-shadow: 22px 0px 35px 0px rgba(0, 0, 0, 0.5);
  }

  hr.hr-text {
    position: relative;
    border: none;
    height: 1px;
    background: #999;
  }

  hr.hr-text::before {
    content: attr(data-content);
    display: inline-block;
    background: #fff;
    font-weight: bold;
    font-size: 0.85rem;
    color: #999;
    border-radius: 30rem;
    padding: 0.2rem 2rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>
